export default "__VITE_ASSET__reWFt__8__"